import { render, staticRenderFns } from "./padlet_listitem.vue?vue&type=template&id=70a83776&scoped=true&"
import script from "./padlet_listitem.vue?vue&type=script&lang=js&"
export * from "./padlet_listitem.vue?vue&type=script&lang=js&"
import style0 from "./padlet_listitem.vue?vue&type=style&index=0&id=70a83776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a83776",
  null
  
)

export default component.exports